<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="main-container">
    <el-col
      :sm="8"
      :lg="7"
      :xl="6"
      class="goals-main-list">
      <el-row>
        <el-col class="main-header">
          <h1>Objetivos</h1>
          <el-button
            circle
            @click="onShowGoalsPanel">
            <i class="icon-plus"/>
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <goals-list
            :goals-items="listItems"
            :goals="listItemsGoals"
            :hide-actions="profile.role !== 'superadmin'"
            goals-items-type="dealer"
            @clickOnItem="clickOnItem"
            @onEdit="onEdit"/> <!-- TODO: change to respective type -->
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :sm="16"
      :lg="17"
      :xl="18"
      class="container-section-main">
      <goals-chart-preview
        :goals="currentGoals"
        :global-goals="globalGoals"
        :item="currentGoalItem"
        :met-goals="metGoals"
        :show-global="showGlobal"
        item-type="dealer"
        @show-global="toggleGoals"/> <!-- TODO: change to respective type -->
    </el-col>
    <goals-create-panel
      v-if="showGoalsPanel"
      :edit="edit"
      :items="listItems"
      :item="currentGoalItem"
      :goals="currentGoals"
      item-type="dealer"
      @closeModal="onCloseGoalsPanel"
      @onCreate="reloadList"/> <!-- TODO: change to respective type -->
  </el-row>
</template>

<script>
/**
*
* GoalsDealerView Component
*
* @author Eduardo Espinosa
* @copyright 2018, Marciano Studio S.C.
*/
import GoalsList from '@/modules/goals/goals-dealer-list.vue'
import GoalsChartPreview from '@/modules/goals/goals-chart-preview.vue'
import GoalsCreatePanel from './goals-create-panel.vue'
import GoalsGuards from '@/guards/goals.guards'
import multiguard from 'vue-router-multiguard'

export default {
  name: 'GoalsDealerView',
  components: {
    GoalsList,
    GoalsChartPreview,
    GoalsCreatePanel
  },
  data () {
    return {
      showGoalsPanel: false,
      edit: false,
      showGlobal: true,
      fullscreenLoading: false
    }
  },
  computed: {
    listItems () {
      return this.$store.getters['dealers/items'] // TODO: change to respective resource
    },
    globalGoals () {
      return this.$store.getters['dealerGoals/globalGoals']
    },
    itemsGoals () {
      if (this.showGlobal) {
        return this.$store.getters['dealerGoals/globalGoals'] // TODO: change to respective resource
      } else {
        return this.$store.getters['dealerGoals/items'] // TODO: change to respective resource
      }
    },
    listItemsGoals () {
      return this.$store.getters['dealerGoals/items'] // TODO: change to respective resource
    },
    metGoals () {
      if (this.showGlobal) {
        return this.$store.getters['dealerGoals/globalMetGoals'] // TODO: change to respective resource
      } else {
        return this.$store.getters['dealerGoals/metGoals'] // TODO: change to respective resource
      }
    },
    currentGoalItem () {
      let _currentId = this.$route.params.id // || (this.listItems.length ? this.listItems[0].id : null)
      if (!_currentId) {
        return null
      }
      return this.listItems.find(item => {
        return parseInt(_currentId) === parseInt(item.id)
      })
    },
    currentGoals () {
      let _currentId = this.$route.params.id
      if (this.showGlobal) {
        return this.itemsGoals
      } else {
        if (!_currentId) {
          return []
        }
        return this.itemsGoals.filter(goal => {
          return parseInt(_currentId) === parseInt(goal.dealerId) // TODO: change to respective id
        })
      }
    },
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    onEdit (item) {
      this.clickOnItem(item)
      this.edit = true
      this.showGoalsPanel = true
      this.$forceUpdate()
    },
    onShowGoalsPanel () {
      this.edit = false
      this.showGoalsPanel = true
    },
    onCloseGoalsPanel () {
      this.showGoalsPanel = false
    },
    clickOnItem (item) {
      if (this.profile.role !== 'territorial_agco') {
        let _query = {}
        _query['dealerId'] = item.id
        this.fullscreenLoading = true
        this.$store.dispatch('assignedGoals/get', { ..._query, limit: 1000, type: 'branch' })
          .finally(() => {
            this.fullscreenLoading = false
          })
      }
      this.$router.push({...this.$route, params: {id: item.id}})
      // this.toggleGoals(false)
      this.showGlobal = false
    },
    toggleGoals (show) {
      this.showGlobal = show
      if (this.profile.role !== 'territorial_agco') {
        this.fullscreenLoading = true
        if (show) {
          this.$store.dispatch('assignedGoals/get', { limit: 1000, type: 'all' })
            .finally(() => {
              this.fullscreenLoading = false
            })
        } else {
          if (this.$route.params.id) {
            let _query = {}
            _query['dealerId'] = this.$route.params.id
            this.$store.dispatch('assignedGoals/get', { ..._query, limit: 1000, type: 'branch' })
              .finally(() => {
                this.fullscreenLoading = false
              })
          }
        }
      }
    },
    reloadList () {
      this.$router.push({...this.$route, query: {...this.$route.query, reload: Date.now()}})
    }
  },
  beforeRouteUpdate: multiguard([
    GoalsGuards.onQueryGoalItems('dealers'),
    GoalsGuards.onQuery('dealerGoals'),
    GoalsGuards.onQueryMetGoals('dealerGoals', 'dealers/items'),
    GoalsGuards.onQueryGlobalGoals('dealerGoals'),
    GoalsGuards.onQueryGlobalMetGoals('dealerGoals')
    // GoalsGuards.onQueryAssignedGoals('branch', 'dealerId')
  ]) // TODO: change to respective resource
}
</script>

<style lang='scss' scoped>
    .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .goals-main-list{
      height: calc(100% - 60px);
      padding: 0 15px;
      border-right: 1px solid $border-primary;
      position: relative;
      overflow: auto;
      background-color: #ffffff;
      .main-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          @include font-primary(21px, regular);
          color: #707070;
        }
        .el-button {
          background-color: $primary;
          border: none;
          color: #ffffff;
          box-shadow: 0 3px 6px 0 rgba(#E7120E, 0.5);
          font-size: 22px;
          padding: 7px;
        }
      }
    }
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      overflow: auto;
      margin-right: -50px;
      background-color: $secondary;
      padding: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/app/goals/goals-dealer.view.vue